module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-2.c5d70e75.mp3";